import { render, staticRenderFns } from "./ConfigAlertAmazonSes.vue?vue&type=template&id=ef3cf4dc&"
import script from "./ConfigAlertAmazonSes.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertAmazonSes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports